import { SessionExpiredDialog } from '@rio-cloud/rio-session-expired-info';
import ApplicationLayout from '@rio-cloud/rio-uikit/ApplicationLayout';
import ApplicationLayoutBodyNavigation from '@rio-cloud/rio-uikit/ApplicationLayoutBodyNavigation';
import NotificationsContainer from '@rio-cloud/rio-uikit/NotificationsContainer';
import { useRef } from 'react';
import { IntlProvider } from 'react-intl';
import { Outlet } from 'react-router-dom';

import { DEFAULT_LOCALE } from '../configuration/lang/lang';
import { getDisplayMessages, getLocale } from '../configuration/lang/langSlice';
import { isUserSessionExpired } from '../configuration/login/loginSlice';
import { useAppDispatch, useAppSelector } from '../configuration/setup/hooks';
import { getSessionExpiredAcknowledged, hideSessionExpiredDialog } from '../data/appSlice';
import { AppContext } from './AppContext';
import SubNavigationBar from './SubNavigationBar';

const AppLayout = () => {
    const dispatch = useAppDispatch();

    const sidebarRef = useRef<HTMLDivElement>(null);

    const userLocale = useAppSelector(getLocale);
    const displayMessages = useAppSelector(getDisplayMessages);
    const isSessionExpired = useAppSelector(isUserSessionExpired);
    const sessionExpiredAcknowledged = useAppSelector(getSessionExpiredAcknowledged);

    if (!(displayMessages && userLocale)) {
        return null;
    }

    const handleSessionExpiredDialogClose = () => dispatch(hideSessionExpiredDialog());
    const showSessionExpired = isSessionExpired && !sessionExpiredAcknowledged;

    return (
        <IntlProvider defaultLocale={DEFAULT_LOCALE} key={userLocale} locale={userLocale} messages={displayMessages}>
            <AppContext.Provider value={{ sidebarRef }}>
                <ApplicationLayout data-testid='app-layout'>
                    <ApplicationLayout.Sidebar className='right' ref={sidebarRef} />

                    <ApplicationLayout.Body
                        navigation={
                            <ApplicationLayoutBodyNavigation>
                                <SubNavigationBar />
                            </ApplicationLayoutBodyNavigation>
                        }
                    >
                        <NotificationsContainer />
                        <SessionExpiredDialog
                            locale={userLocale}
                            onClose={handleSessionExpiredDialogClose}
                            show={showSessionExpired}
                        />
                        <Outlet />
                    </ApplicationLayout.Body>
                </ApplicationLayout>
            </AppContext.Provider>
        </IntlProvider>
    );
};

export default AppLayout;
